import { getCookie, useGetContext } from '../lendingApi/lendingApiQueries';
import { TGetContext } from '../types';

export const truthyValues = ['True', 'true', true];

type TSplitTextFromContext = TGetContext['data']['user_split_tests'][number];

export const getSplitTestFromContext = (
  splitTestToFind: string,
  context: TGetContext['data'],
) => {
  const overrideCookie = getCookie(`split_test_${splitTestToFind}`);

  if (overrideCookie !== null)
    return {
      [splitTestToFind]: truthyValues.includes(overrideCookie),
    };

  return context?.user_split_tests?.find(
    (splitTest) =>
      splitTest && Object.keys(splitTest).includes(splitTestToFind),
  );
};

export function useSplitTestContext() {
  const { context } = useGetContext();

  const hasSplitTestEnabledWithContext = (
    splitTestToFind: keyof TSplitTextFromContext,
    splitTestValue?: TSplitTextFromContext[keyof TSplitTextFromContext],
  ) => {
    const splitTest = getSplitTestFromContext(splitTestToFind, context);

    if (!splitTest) return false;

    if (!splitTestValue) {
      return Boolean(splitTest[splitTestToFind]);
    }

    if (
      typeof splitTestValue === 'string' &&
      splitTest[splitTestToFind] === splitTestValue
    ) {
      return true;
    } else return false;
  };

  return {
    splitTests: context?.user_split_tests,
    hasMockSplitTestEnabled: hasSplitTestEnabledWithContext('mock_split_test'),
    hasMiddleNameTestEnabled: hasSplitTestEnabledWithContext(
      'partner_middle_name_test_2025',
    ),
    hasInterestOnlyEnabled: hasSplitTestEnabledWithContext(
      'signup_interest_only_test_2023',
    ),
    hasBusinessDetailsReductionEnabled: hasSplitTestEnabledWithContext(
      'business_details_reduction',
    ),
  };
}
